import { Component, OnInit, Inject } from '@angular/core';
import { ISelectoptionsMultiple } from '../../../../interfaces/abstract';
import { IManureNViewModel } from '../../interfaces';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { ManureNFields } from '../../calculatorSettingsForm';
import { FormValidation } from '../../../../classes/formValidation';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CoverCropComponent } from './cover-crop';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';

@Component({
	moduleId: module.id,
	selector: 'manure-calculator',
	templateUrl: 'manure.html'
})

export class ManureComponent implements OnInit {

	public isValid: boolean;

	public manureTypeOptions: ISelectoptionsMultiple[] = [
		{ keys: [29, 0.3], label: 'Chicken Manure' },
		{ keys: [52, 2.6], label: 'Fresh Bovine Waste' },
		{ keys: [20, 7.5], label: 'Dry Corral Manure, 2.5%N' },
		{ keys: [10, 3], label: 'Dry Corral Manure, 1.5%N' },
		{ keys: [4, 1.6], label: 'Dry Corral Manure, 1.0%N' },
		{ keys: [18, 3.2], label: 'Liquid Sludge, 2.5%N' },
		{ keys: [0, 0], label: 'No Manure' },
	];

	public get f(): { [key in ManureNFields]: AbstractControl } {
		return this.form.controls as { [key in ManureNFields]: AbstractControl };
	}

	public form: FormGroup;
	private _initialValues: IManureNViewModel; // cache initial values
	private _control: AbstractControl;

	constructor(
		private _dialogRef: MatDialogRef<CoverCropComponent>,
		@Inject(MAT_DIALOG_DATA) private _data: { form: FormGroup, control: AbstractControl },
		private _sharedUpdateService: SharedUpdateService,
	) {}

	ngOnInit(): void {
		this.form = this._data.form;
		this._control = this._data.control;
		this._initialValues = this.form.value;
		this._setValidators();
	}

	public calculate(e: MouseEvent): void {
		let result: number;

		result = this.f.RatePriorYear.value * this.f.TypePriorYear.value +
			this.f.RateTwoYearsAgo.value * this.f.TypeTwoYearsAgo.value;

		result = parseFloat(result.toFixed(2));

		this._clearValidators();
		this._control.setValue(result);
		this._closeDialog();
	}

	public cancel(e: MouseEvent): void {
		this.form.reset(this._initialValues);
		this._clearValidators();
		this._closeDialog();
	}

	private _closeDialog() {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}

	private _setValidators(): void {
		this.f.RatePriorYear.setValidators(Validators.min(0));
		this.f.RateTwoYearsAgo.setValidators(Validators.min(0));
		this.form.setValidators(this._manureValidator);
	}

	private _clearValidators(): void {
		FormValidation.clearValidator(this.f.RatePriorYear);
		FormValidation.clearValidator(this.f.RateTwoYearsAgo);
		FormValidation.clearValidator(this.f.TypePriorYear);
		FormValidation.clearValidator(this.f.TypeTwoYearsAgo);
		FormValidation.clearValidator(this.form);
	}

	private _manureValidator(g: FormGroup): { noPositiveResult: boolean } {
		let ratePriorYear: AbstractControl = g.get('RatePriorYear');
		let typePriorYear: AbstractControl = g.get('TypePriorYear');
		let rateTwoYearsAgo: AbstractControl = g.get('RateTwoYearsAgo');
		let typeTwoYearsAgo: AbstractControl = g.get('TypeTwoYearsAgo');
		let error: { noPositiveResult: boolean } = { noPositiveResult: true };

		if (ratePriorYear.value * typePriorYear.value > 0 ||
			rateTwoYearsAgo.value * typeTwoYearsAgo.value > 0) {

			FormValidation.removeErrorFromContrl(typePriorYear, 'noPositiveResult');
			FormValidation.removeErrorFromContrl(ratePriorYear, 'noPositiveResult');
			FormValidation.removeErrorFromContrl(typeTwoYearsAgo, 'noPositiveResult');
			FormValidation.removeErrorFromContrl(rateTwoYearsAgo, 'noPositiveResult');

			return;
		} else {
			if (ratePriorYear.value && ratePriorYear.valid) {
				typePriorYear.setErrors(error);
			}

			if (typePriorYear.value) {
				ratePriorYear.setErrors(error);
			}

			if (rateTwoYearsAgo.value && rateTwoYearsAgo.valid) {
				typeTwoYearsAgo.setErrors(error);
			}

			if (typeTwoYearsAgo.value) {
				rateTwoYearsAgo.setErrors(error);
			}
		}
	}
}
